<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

<h5>Leilões</h5>
<div class="container">
  <form
    [formGroup]="pesquisaForm"
    class="mt-3 mx-auto"
    (keyup.enter)="focusableSubmit.click()"
  >
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button
          class="btn btn-primary no-margin"
          type="button"
          [routerLink]="['/leilao/cadastro/lote']"
          placement="bottom"
          [disabled]="!podeEnviarArquivo"
          ngbTooltip="Selecione esta opção para enviar um arquivo contendo os leilões realizados."
        >
          <i class="fa fa-file-signature"> </i> Enviar arquivo de leilões
          realizados
        </button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">
          Limpar
        </button>
      </div>
      <div class="col-auto">
        <button
          #focusableSubmit
          type="button"
          class="btn btn-success no-margin"
          (click)="buscar(false, true)"
          [disabled]="!pesquisaForm.valid"
        >
          Pesquisar
        </button>
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <ng-select
          [items]="agentesFinanceiros"
          bindLabel="nome"
          placeholder="Todos"
          [disabled]="!podeEscolherAgente"
          formControlName="agenteFinanceiro"
        >
        </ng-select>

      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioInicio">Data de envio inicial:</label>
        <bn-datepicker
          name="dataEnvioInicio"
          idInput="dataEnvioInicio"
          formControlName="dataEnvioInicio"
        >
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioFim">Data de envio final:</label>
        <bn-datepicker
          name="dataEnvioFim"
          idInput="dataEnvioFim"
          formControlName="dataEnvioFim"
        >
        </bn-datepicker>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <label class="form-label" for="idProtocoloArquivo"
          >Id. de protocolo:
          <i
            class="fa fa-question-circle help-subtitulo"
            placement="bottom"
            ngbTooltip="Identificador de protocolo do arquivo de operações leiloadas enviado"
          ></i
        ></label>
        <input
          type="text"
          class="form-control"
          formControlName="idProtocoloArquivo"
        />
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="estado">Estado:</label>
        <select
          id="estado"
          class="form-control"
          [compareWith]="compararPorId"
          formControlName="estado"
        >
          <option [ngValue]="null">Todos</option>
          <option *ngFor="let item of estados" [ngValue]="item">
            {{ item.nome }}
          </option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="sistema"
          >Sistema:
          <i
            class="fa fa-question-circle help-subtitulo"
            placement="bottom"
            ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES ou Crédito Livre."
          ></i>
        </label>
        <select
          id="sistema"
          class="form-control"
          [compareWith]="compararPorId"
          formControlName="sistema"
        >
          <option [ngValue]="null">Todos</option>
          <option [ngValue]="'CL'">Crédito Livre</option>
          <option [ngValue]="'15'">15 - Contratos FINAME</option>
          <option [ngValue]="'89'">89 - Contratos BNDES</option>
        </select>
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label"
          >Id. ext. operação:
          <i
            class="fa fa-question-circle help-subtitulo"
            placement="bottom"
            ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."
          ></i>
        </label>
        <input class="form-control" formControlName="idExternoOperacao" />
      </div>

      <div class="bn-form-group col-md-2">
        <label class="form-label"
          >Contrato:
          <i
            class="fa fa-question-circle help-subtitulo"
            placement="bottom"
            ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."
          ></i>
        </label>
        <input class="form-control" formControlName="contrato" />
      </div>
    </div>
    <div class="row">
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="idCobranca"
          >Id. leilão:
          <i
            class="fa fa-question-circle help-subtitulo"
            placement="bottom"
            ngbTooltip="Identificador do leilão gravado no sistema"
          ></i
        ></label>
        <input type="text" class="form-control" formControlName="idLeilao" />
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="idCobranca"
          >Id. cobrança:
          <i
            class="fa fa-question-circle help-subtitulo"
            placement="bottom"
            ngbTooltip="Identificador da cobrança que o leilão foi incluído"
          ></i
        ></label>
        <input type="text" class="form-control" formControlName="idCobranca" />
      </div>
    </div>
  </form>
</div>

<app-consulta-status-leilao-listagem
  [setDetalhesLeilao]="detalhesLeilao"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  *ngIf="pesquisado"
  [hidden]="esconderPesquisa"
  (aoMudarPagina)="mudancaPagina($event)"
></app-consulta-status-leilao-listagem>
